<script>
import { mapActions, mapState } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';

export default {
  name: 'CpLobbyAction',
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginBottom: require('../../directives/margins').marginBottom,
  },
  components: {
    CpTooltip: require('../../tooltip').default,
    CpTooltipToggle: require('../../tooltip-toggle').default,
    CpActionButtons: require('./ActionButtons').default,
    CpLobbyFormDialog: require('../../dialogs/LobbyFormDialog').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpVerifyEmailDialog: require('../../dialogs/VerifyEmail').default,
  },
  props: {
    politician: Object,
    modalFeed: { type: Boolean, default: false },
    refProp: { type: Object, default: null },
    showOnlyIcon: { type: Boolean, default: false },
    showTitleButton: { type: Boolean, default: true },
    withTooltip: { type: Boolean, default: true },
    callback: { type: Function },
  },
  async mounted() {
    if (this.isUserLogin && !this.userProfileData) {
      await this.getUserProfile();
    }
  },
  data() {
    return {
      loadingTypeLobby: false,
      type: '',
      showDialog: false,
      showAuthModal: false,
      showVerifyEmailModal: false,
    };
  },
  methods: {
    async handleTypeLobby(type) {
      this.lobbyError = false;
      if (this.isUserLogin && !this.userProfileData?.email_verified) {
        await this.getUserProfile();
      }
      this.type = type;
      if (!this.isUserLogin && !this.modalFeed) {
        this.showAuthModal = true;
      } else if (!this.userProfileData?.email_verified) {
        this.showVerifyEmailModal = true;
      } else {
        this.startLobby();
      }
    },
    startLobby() {
      this.showDialog = true;
      this.loadingTypeLobby = true;
    },
    handleVerifyEmailModal() {
      this.showVerifyEmailModal = !this.showVerifyEmailModal;
    },
    handleDialog() {
      if (this.showDialog) {
        this.loadingTypeLobby = false;
      }
      this.showDialog = !this.showDialog;
    },
    handleStartLobby() {
      this.showAuthModal = !this.showAuthModal;
    },
    handlePhoneBlur() {
      const formatted = this.formatPhone(this.phone);
      if (formatted !== this.phone) {
        this.phone = formatted;
      }
      this.phoneError = this.validatePhone(this.phone);
    },
    ...mapActions(useUserStore, ['getUserProfile']),
  },
  computed: {
    ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
  },
};
</script>
<template>
  <div>
    <template>
      <p v-if="showTitleButton" class="body1 neutral4-color" v-margin-bottom="0">Contact Rep. {{ politician?.last_name || politician.last_suffix }}</p>
      <div v-if="withTooltip">
        <CpTooltipToggle for="lobbyAction" hoverable>
          <CpActionButtons :handleAction="handleTypeLobby" :loading="loadingTypeLobby" :showOnlyIcon="showOnlyIcon" />
        </CpTooltipToggle>
        <CpTooltip light unstyled :max-width="$root.isMobile ? '80vw' : '50vw'" style="left: 10%" id="lobbyAction">
          <span class="tooltipOption body1 neutral6-color"
            ><i class="fal fa-info-circle tooltipIcon"></i>
            <p>
              Click <b>Endorse</b> or <b>Oppose</b> to get started. You’ll be able to write a short message that will be sent directly to your elected official
              and their team.
            </p></span
          >
        </CpTooltip>
      </div>
      <div v-else>
        <CpActionButtons :handleAction="handleTypeLobby" :loading="loadingTypeLobby" :showOnlyIcon="showOnlyIcon" />
      </div>
    </template>
    <CpLobbyFormDialog
      v-if="showDialog"
      :politician="politician"
      :showDialog="showDialog"
      :type="type"
      :modalFeed="modalFeed"
      :refProp="refProp"
      :callback="callback"
      @close="handleDialog"
    />
    <CpVerifyEmailDialog v-if="showVerifyEmailModal" :handleDialog="handleVerifyEmailModal" />
    <CpDialogAuthForm v-if="showAuthModal" :handleCloseButton="handleStartLobby" :callback-action="startLobby" />
  </div>
</template>
<style scoped>
.tooltipOption {
  display: flex;
  align-items: center;
  padding: 8px;
}
.tooltipIcon {
  margin-right: 10px;
}
</style>
